import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
// import reportWebVitals from './reportWebVitals';

import { AmazonContextProvider } from "./Context/AppGlobalData";
import { PupupContextProvider } from "./Context/PopupMessage";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./i18n";

// css on first load
import "./styles/App.css";
// import "./styles/sidebar.css";
import "./styles/Tabs.css";
// import "./styles/ToggleButton.css"
import "./styles/newSkin.css";

// import "./styles/Content.css";
import "react-tabs/style/react-tabs.css";

import { LicenseInfo } from "@mui/x-data-grid-pro";
import { MaterialPropertiesProvider } from "./Context/MaterialPropertiesContext";

LicenseInfo.setLicenseKey(
  "6c128a169ce009ec686d2e99f2d76686T1JERVI6MzI3NDIsRVhQSVJZPTE2Njg2OTE2MzIwMDAsS0VZVkVSU0lPTj0x"
);

const lightTeal = "#D2E0E8";
const darkTeal = " #6D92A5";
const mediumTeal = " #A0BBCA";
const yellow = "#FFEC9B";
const themeNew = createTheme({
  overrides: {
    "&.MuiOutlinedInput-adornedEnd": {
      marginLeft: 0,
    },

    MuiInputBase: {
      input: {
        background: "#fff",
      },
    },
  },
  MuiSwitch: {
    root: {
      height: 120,
    },

    switchBase: {
      // Controls default (unchecked) color for the thumb
      color: "black",
    },
    colorSecondary: {
      "&$checked": {
        // Controls checked color for the thumb
        color: "blue",
      },
    },
    track: {
      // Controls default (unchecked) color for the track
      opacity: 0.2,
      backgroundColor: "#fff",
      "$checked$checked + &": {
        // Controls checked color for the track
        opacity: 0.7,
        backgroundColor: "#fff",
      },
    },
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: {},
          style: {
            "&:disabled": {
              opacity: "0.65",
              pointerEvents: "none",
              color: "white",
            },
            width: " 120px",
            height: "30px",
            minHeight: "auto",
            minWidth: "auto",
            backgroundColor: "#5b7a8f", //todo
            color: "#FFFFFF",
            //   boxShadow:
            //     "0 2px 2px 0 rgba(153, 153, 153, 0.14), 0 3px 1px -2px rgba(153, 153, 153, 0.2), 0 1px 5px 0 rgba(153, 153, 153, 0.12)",
            border: "none",
            borderRadius: "5px",
            position: "relative",
            padding: "5px 5px",
            // margin: ".3125rem 1px",
            fontSize: "12px",
            fontWeight: "400",
            textTransform: "capitalize",
            letterSpacing: "0",
            willChange: "box-shadow, transform",
            transition:
              "box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
            lineHeight: "1.42857143",
            textAlign: "center",
            whiteSpace: "nowrap",
            verticalAlign: "middle",
            touchAction: "manipulation",
            cursor: "pointer",
            "&:hover,&:focus": {
              color: "#FFFFFF",
              backgroundColor: " #5b7a8f", //todo
              // boxShadow: `0 14px 26px -12px ${primaryColor}, 0 4px 23px 0px ${primaryColor}, 0 8px 10px -5px ${primaryColor}`
            },
            "& .fab,& .fas,& .far,& .fal,& .material-icons": {
              position: "relative",
              display: "inline-block",
              top: "0",
              fontSize: "1.1rem",
              marginRight: "2px",
              verticalAlign: "middle",
            },

            "& svg": {
              position: "relative",
              display: "inline-block",
              top: "0",
              // width: "18px",
              // height: "18px",
              marginRight: "2px",

              verticalAlign: "middle",
            },
            "&$justIcon": {
              "& .fab,& .fas,& .far,& .fal,& .material-icons": {
                marginRight: "0px",
                position: "absolute",
                width: "100%",
                transform: "none",
                left: "0px",
                top: "0px",
                height: "100%",
                lineHeight: "41px",
                fontSize: "20px",
              },
            },
          },
        },
        {
          props: { styletype: "fullWidth" },
          style: {
            width: "100%",
          },
        },
        {
          props: { styletype: "lightTeal" },
          style: {
            backgroundColor: lightTeal, //todo,
            color: "#000000",
            // boxShadow: "0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)",
            "&:hover,&:focus": {
              backgroundColor: `${lightTeal}`,
              boxShadow: `0 5px 10px -6px ${lightTeal}`,
              color: "#000000",
            },
          },
        },
        {
          props: { styletype: "darkTeal" },
          style: {
            backgroundColor: darkTeal, //todo,
            color: "#000000",
            // boxShadow: "0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)",
            "&:hover,&:focus": {
              backgroundColor: `${darkTeal}`,
              boxShadow: `0 5px 10px -6px ${darkTeal}`,
              color: "#000000",
            },
          },
        },
        {
          props: { styletype: "upload" },
          style: {
            height: "2em !important",
            // boxShadow: "0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)",
            // "&:hover,&:focus": {
            //   backgroundColor: `white`,
            //   boxShadow: `0 5px 10px -6px $white`,
            //   color: "#000000"
            // }
          },
        }, 
        
        {
          props: { styletype: "danger" },
          style: {
            width: 30,
            height: 30,
            minWidth: "auto",
            backgroundColor: " #A80019", //todo,
            color: "#ffffff",
            "&:hover,&:focus": {
              backgroundColor: "#A80019",
              boxShadow: `0 5px 10px -6px #A80019`,
              color: "#ffffff",
            },
          },
        },
        {
          props: { styletype: "pinbtn" },
          style: {
            width: 30,
            height: 30,
            minWidth: "auto",
            backgroundColor: "orangered", //todo,
            color: "black",
            "&:hover,&:focus": {
              backgroundColor: "orangered",
              boxShadow: `0 5px 10px -6px #A80019`,
              color: "black",
            },
          },
        },
        {
          props: { styletype: "icon" },
          style: {
            width: "30px",
            height: "30px",

            // height: "2.5rem",
            // backgroundColor:  " #A80019",//todo,
            color: "#ffffff",
          },
        },
        {
          props: { styletype: "modalIcon" },
          style: {
            width: "24px",
            height: "24px",

            // height: "2.5rem",
            // backgroundColor:  " #A80019",//todo,
            color: "#ffffff",
          },
        },

        {
          props: { styletype: "go" },
          style: {
            marginBottom: "2px",
            width: "30px",
            height: "28px",
            // backgroundColor:  " #A80019",//todo,
            color: "#ffffff",
          },
        },

        {
          props: { styletype: "disabled" },
          style: {
            opacity: "0.65",
            pointerEvents: "none",
          },
        },

        {
          props: { styletype: "goNext" },
          style: {
            marginBottom: "2px",
            width: "30px",
            height: "28px",
            backgroundColor: yellow, //todo,
            color: "#ffffff",
            "&:hover,&:focus": {
              backgroundColor: yellow,
              boxShadow: `0 5px 10px -6px #A80019`,
              color: "#ffffff",
            },
          },
        },

        {
          props: { styletype: "mediumTeal" },
          style: {
            backgroundColor: mediumTeal, //todo,
            color: "#000000",
            // boxShadow: "0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)",
            "&:hover,&:focus": {
              backgroundColor: `${mediumTeal}`,
              boxShadow: `0 5px 10px -6px ${mediumTeal}`,
              color: "#000000",
            },
          },
        },

        {
          props: { styletype: "warning" },
          style: {
            backgroundColor: "#0000000", //todo
            boxShadow:
              "0 2px 2px 0 rgba(255, 152, 0, 0.14), 0 3px 1px -2px rgba(255, 152, 0, 0.2), 0 1px 5px 0 rgba(255, 152, 0, 0.12)",
            "&:hover,&:focus": {
              backgroundColor: "#0000000", //todo
              boxShadow:
                "0 14px 26px -12px rgba(255, 152, 0, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(255, 152, 0, 0.2)",
            },
          },
        },

        {
          props: { styletype: "close" },
          style: {
            width: "28px",
            height: "28px",
            backgroundColor: darkTeal, //todo,
            color: "#ffffff",
            "&:hover,&:focus": {
              backgroundColor: darkTeal,
              boxShadow: `0 5px 10px -6px ${darkTeal}`,
              color: "#ffffff",
            },
          },
        },

        {
          props: { styletype: "backBtn" },
          style: {
            width: "28px",
            height: "28px",
            backgroundColor: "#ffffff", //todo,
            color: darkTeal,
            "&:hover,&:focus": {
              backgroundColor: "#ffffff",
              boxShadow: `0 5px 10px -6px ${darkTeal}`,
              color: darkTeal,
            },
          },
        },

        {
          props: { styletype: "justIcon" },
          style: {
            paddingLeft: "12px",
            paddingRight: "12px",
            fontSize: "30px",
            height: "41px",
            minWidth: "41px",
            width: "41px",
            "& .fab,& .fas,& .far,& .fal,& svg,& .material-icons": {
              marginRight: "0px",
            },
            "&$lg": {
              height: "57px",
              minWidth: "57px",
              width: "57px",
              lineHeight: "56px",
              "& .fab,& .fas,& .far,& .fal,& .material-icons": {
                fontSize: "32px",
                lineHeight: "56px",
              },
              "& svg": {
                width: "32px",
                height: "32px",
              },
            },
            "&$sm": {
              height: "30px",
              minWidth: "30px",
              width: "30px",
              "& .fab,& .fas,& .far,& .fal,& .material-icons": {
                fontSize: "17px",
                lineHeight: "29px",
              },
              "& svg": {
                width: "17px",
                height: "17px",
              },
            },
          },
        },
      ],
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          display: "inline-flex",

          border: " 2px solid #5B7A8F",
          // background: "#5B7A8F",
          borderRadius: "5px",
          height: "100%",
        },
      },
    },

    MuiDataGrid: {
      styleOverrides: {
        // Name of the slot
        overlay: { display: "none" }, // disable no rows message

        root: {
          border: "1px solid #6D92A5",

          // color:"blue",
          "& .MuiDataGrid-row": {
            "&:nth-of-type(2n)": {
              backgroundColor: " #EBF0F4 ", //even tealcolor
              "&:hover": {
                background: " #EBF0F4  !important",
              },
            },
          },

          "& .MuiDataGrid-row:hover": {
            backgroundColor: "white !important",
          },

          "&.MuiDataGrid-root .MuiDataGrid-main": {
            backgroundColor: "white",
          },
          "& .MuiDataGrid-columnHeaderDraggableContainer": {
            // allow double click to select header.
            userSelect: "auto",
          },
          "&.MuiDataGrid-root .MuiDataGrid-columnHeaders": {
            backgroundColor: "#D2E0E8",
            color: "#5B7A8F",
            // minHeight: "40px !important",

            // maxHeight: "40px !important"
          },

          "&.MuiDataGrid-root .MuiDataGrid-virtualScroller": {
            // marginTop: "45px !important",
          },
          "&.MuiDataGrid-root .MuiDataGrid-columnHeaderTitleContainer": {
            padding: 0,
          },

          // Some CSS
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#6D92A5",
          "&.Mui-checked": {
            color: "#6D92A5",
          },
        },
      },
    },

    MuiInputAdornment: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          marginLeft: -5,
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        // Name of the slot
        root: {
          //  margin:"0 0 0 5px",
          "& .MuiOutlinedInput-root ": {
            padding: "0",
            // margin:"0 0 0 5px",
          },
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          "& .MuiGrid-item": {
            paddingLeft: "10px",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        // Name of the slot
        root: {
          height: "2em",
          paddding: 0,
          borderRadius: "5px",
          // marginLeft: "5px",
          // margin:"0 0 0 5px",
          // width: width,
          // margin:margin,
          background: "white",
          // height:"24px",
          "&  .Mui-disabled": {
            background: "rgba(227,227, 227,227);",
          },
          "& .MuiOutlinedInput-input  ": {
            padding: "4px!important",

            // paddingLeft: "5px!important"
          },
        },
      },
    },
  },
  palette: {
    primary: {
      // Purple and green play nicely together.
      main: "#a0bbca",
    },
    secondary: {
      // This is green.A700 as hex.
      main: "#11cb5f",
    },
  },
});
ReactDOM.render(
  <AmazonContextProvider>
    <ThemeProvider theme={themeNew}>
      <PupupContextProvider>
        <MaterialPropertiesProvider>
          <App />
        </MaterialPropertiesProvider>
      </PupupContextProvider>
    </ThemeProvider>
  </AmazonContextProvider>,
  document.getElementById("root")
);
